import React from 'react';

import { PaginationPanel } from '@vlabs/uikit/components/pagination-v2';

import { useRoleListFilters } from '@vlabs/monokit/entities/roles';
import { useGetRoles } from '@vlabs/api/artemy/client';

import { RoleListTable } from './role-list-table/RoleListTable';
import st from './RoleListTableViewer.module.sass';

function RoleListTableViewer(): React.JSX.Element {
  const { filters, updateFilters } = useRoleListFilters();
  const getRoles = useGetRoles(filters);
  const rolesData = getRoles.data?.roles ?? [];

  return (
    <React.Fragment>
      <RoleListTable roles={rolesData} />
      <div className={st.Pagination}>
        <PaginationPanel
          canNextPage={rolesData.length >= (filters.page_size ?? 0)}
          canPreviousPage={(filters?.page ?? 0) > 1}
          gotoPage={(page) => updateFilters({ page: page + 1 })}
          nextPage={() => updateFilters({ page: (filters?.page ?? 0) + 1 })}
          pageCount={Math.ceil((rolesData.length ?? 0) / (filters?.page_size ?? 25))}
          pageIndex={(filters?.page ?? 1) - 1}
          pageSize={filters.page_size}
          previousPage={() => updateFilters({ page: (filters?.page ?? 0) - 1 })}
          setPageSize={(page_size: number) => updateFilters({ page_size })}
        />
      </div>
    </React.Fragment>
  );
}

export { RoleListTableViewer };
